module.exports = __webpack_public_path__ + "img/20241129101902.06199812.jpg";